import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserRolesService } from './user-roles.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

    constructor(private router: Router, private userRoleService: UserRolesService,) { }

    async getAuthenticated(roleId:any, url:any) {
        // if the roleId is not present in the local storage, get it from the userRoleService
        if (!roleId) {
            await this.userRoleService.getUserRoles().pipe(
                map(res => {
                    if (res) {
                        roleId = res.HighestRoleId;
                    }
                })
            ).toPromise();
        }

        if (roleId == 0 || roleId == '' || roleId == null || roleId == undefined) {
            this.router.navigate(['/unauthorised']);
            return false;
        }
        if (url.indexOf("?")> -1) {
            url = url.substr(0, url.indexOf("?"));
        }
        switch (url) {
            case '/addSession':
                return true;
            case '/editSubscription':
              if (roleId === 1 || roleId === 3 || roleId === 6) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/security':
                if (roleId === 1 || roleId === 3) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/additionalQuestionsReport':
                if (roleId === 1) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/dataCleanup':
            if (roleId === 1 || roleId === 3) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/manageMailBox':
                if (roleId === 1) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/manageCountryMailbox':
                if (roleId === 1) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/searchEmailTemplate':
                if (roleId === 1) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/manageEmailTemplate':
            case '/createClient':
            case '/searchOrganization':
                if (roleId === 1) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            case '/addSubscription':
                    return true;
            case '/searchSubscription':
              if (roleId === 1 || roleId === 3 || roleId === 6) {
                    return true;
                }
                this.router.navigate(['/unauthorised']);
                return false;
            default:
                return false;
        }
    }
}
